import type { DBTimestamps } from 'types/db';

function getNow(): number {
  return Date.now();
}
/** method returns the number of milliseconds elapsed since the epoch,
 * which is defined as the midnight at the beginning of January 1, 1970, UTC.
 */
export const dbTimestamps = (createdAt?: number | null | undefined): DBTimestamps => {
  const now = getNow();
  return {
    created_at: createdAt ?? now,
    updated_at: now,
  };
};
